<template>
  <div class="rate-limit-error-widget">
    <svg
      class="rate-limit-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="2"
      />
      <path
        d="M12 6V12L16 14"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <p class="rate-limit-message">
      Too many requests. Please retry after 30 seconds
    </p>
  </div>
</template>

<script setup>
// No props needed - this is a simple display component
</script>

<style scoped>
.rate-limit-error-widget {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  min-height: 120px;
}

.rate-limit-icon {
  width: 48px;
  height: 48px;
  color: #ff9800;
  margin-bottom: 16px;
}

.rate-limit-message {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
  line-height: 1.5;
}
</style>
